var _circle, _rect, _g, _circle2, _path, _rect2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionnaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 130,
    viewBox: "0 0 119 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 9.5,
    cy: 50.375,
    r: 9.375,
    fill: "#00AECC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 26.375,
    y: 44.125,
    width: 92.5,
    height: 12.5,
    rx: 5,
    fill: "#00AECC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 9.5,
    cy: 19.125,
    r: 9.375,
    fill: "#00AECC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 26.375,
    y: 12.875,
    width: 92.5,
    height: 12.5,
    rx: 5,
    fill: "#00AECC"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 81.625,
    r: 9.375,
    fill: "#00AECC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 81.625C15.125 84.7316 12.6066 87.25 9.5 87.25C6.3934 87.25 3.875 84.7316 3.875 81.625C3.875 78.5184 6.3934 76 9.5 76C12.6066 76 15.125 78.5184 15.125 81.625Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.375,
    y: 75.375,
    width: 92.5,
    height: 12.5,
    rx: 5,
    fill: "#00AECC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 9.5,
    cy: 112.875,
    r: 9.375,
    fill: "#00AECC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 26.375,
    y: 106.625,
    width: 92.5,
    height: 12.5,
    rx: 5,
    fill: "#00AECC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaire);
export default __webpack_public_path__ + "static/media/questionnaire.aab41710882194e5d3debf24dbf4a6d5.svg";
export { ForwardRef as ReactComponent };